module.exports = __webpack_public_path__ + "./docs/img/go.c69eee315699c4226ba7484e47040c7d.svg";